import { jsx as t } from "react/jsx-runtime";
import { InputRightElement as o } from "@chakra-ui/react";
import "../Button/Button.mjs";
import { IconButton as i } from "../Button/IconButton.mjs";
import "../Button/ButtonGroup.mjs";
import { CircleXMarkIcon as a } from "../../icons/componentIcons.mjs";
const u = ({
  isSearchBtnDisplayed: r,
  onClick: e
}) => /* @__PURE__ */ t(
  o,
  {
    className: r ? "input-clear-element search-button-repos" : "input-clear-element",
    children: /* @__PURE__ */ t(
      i,
      {
        variant: "ghost",
        "aria-label": "Clear field",
        onClick: e,
        icon: /* @__PURE__ */ t(a, { variant: "solid" })
      }
    )
  }
);
export {
  u as default
};
